import EditPolicyGeneralForm from './EditPolicyGeneralForm';
export default EditPolicyGeneralForm;
